import * as marietta3d from "../../../marietta3d";
import * as THREE from "three";
import { ThreeView, webcadDefines} from "./index";
import { AutoObjDimension } from "../../../marietta3d/AutoGen/object";

class sizeType {
    dimStr: string;
    p1: THREE.Vector3;
    p1w: THREE.Vector3;
    p2: THREE.Vector3;
    p2w: THREE.Vector3 | undefined;
}

class vecType {
    p1w: THREE.Vector3;
    p1: THREE.Vector3;
    p2: THREE.Vector3;
}

export class WebCadDimensionLine {

    constructor() {
    }

    /* addSizeLine
    * 寸法ラインオブジェクトの生成.
    */
    private addSizeLine(x1: number, y1: number, z1: number, x2: number, y2: number, z2: number) {
        return [new THREE.Vector3(x1, y1, z1), new THREE.Vector3(x2, y2, z2)];
    }

    /* createHeightSizeLabelsObject
     * 各階の方向毎のサイズラベルを1つのオブジェクトとして生成する.
     */
    private createHeightSizeLabelsObject(
        sizeArray: sizeType[],
        group1: THREE.Group, group2: THREE.Group, color: string,
    ): void {
        const sizes: string[][] = []; sizes.push([]);
        for (let i = 0; i < sizeArray.length; i++) {
            sizes[0].push(sizeArray[i].dimStr);
        }

        // ラベルすべてを含むの広さのテクスチャ画像を作成.
        WebCadDimensionLine.createSizesTexture(sizes, webcadDefines.LabelTexDefs.fontSize, webcadDefines.LabelTexDefs.baseOff, webcadDefines.LabelTexDefs.texWid, webcadDefines.LabelTexDefs.texHgt, color, (texture: any, width: number, height: number) => {

            const get_vec1 = (p1w: THREE.Vector3, p1: THREE.Vector3, p2: THREE.Vector3): THREE.Vector3[] => {

                const U: THREE.Vector3 = p1w.clone().sub(p1).normalize(); // ラベル文字方向.
                const V_FR: THREE.Vector3 = p2.clone().sub(p1).normalize(); // 前後ラベル高さ方向.
                const V_TB: THREE.Vector3 = V_FR.clone().cross(U).normalize(); // 上下ラベル文字方向.
                const le: THREE.Vector3 = p1.clone().addScaledVector(U, -webcadDefines.LabelTexDefs.hgt * 0.5);

                const vec1 = le.clone().addScaledVector(V_TB, -webcadDefines.LabelTexDefs.off);
                const vec4 = vec1.clone().addScaledVector(U, webcadDefines.LabelTexDefs.wid);
                const vec2 = vec1.clone().addScaledVector(V_TB, -webcadDefines.LabelTexDefs.hgt);
                const vec3 = vec4.clone().addScaledVector(V_TB, -webcadDefines.LabelTexDefs.hgt);

                return [vec1, vec2, vec3, vec4];
            }

            const get_vec2 = (p1w: THREE.Vector3, p1: THREE.Vector3, p2: THREE.Vector3): THREE.Vector3[] => {

                const cn: THREE.Vector3 = p1.clone().add(p2).divideScalar(2);
                const U_FR: THREE.Vector3 = p2.clone().sub(p1).normalize(); // ラベル文字方向.
                const V_FR: THREE.Vector3 = p1w.clone().sub(p1).normalize(); // 上下ラベル高さ方向.
                const U_TB: THREE.Vector3 = V_FR.clone().cross(U_FR).normalize(); // ラベル文字方向.
                const V_TB: THREE.Vector3 = V_FR; // 前後ラベル高さ方向.

                // まず4頂点を準備.
                const vec_ = cn.clone().addScaledVector(V_TB, -webcadDefines.LabelTexDefs.off)
                const vec1 = vec_.clone().addScaledVector(U_TB, -webcadDefines.LabelTexDefs.wid / 2);
                const vec4 = vec_.clone().addScaledVector(U_TB, webcadDefines.LabelTexDefs.wid / 2);
                const vec2 = vec1.clone().addScaledVector(V_TB, -webcadDefines.LabelTexDefs.hgt);
                const vec3 = vec4.clone().addScaledVector(V_TB, -webcadDefines.LabelTexDefs.hgt);

                return [vec1, vec2, vec3, vec4];
            }

            const getVec_top_bottom = (dim_line: sizeType): THREE.Vector3[] => {
                if (dim_line.p2w == undefined) {
                    return get_vec1(dim_line.p1w, dim_line.p1, dim_line.p2);
                } else {
                    return get_vec2(dim_line.p1w, dim_line.p1, dim_line.p2);
                }
            }

            const get_vec3 = (p1w: THREE.Vector3, p1: THREE.Vector3, p2: THREE.Vector3): THREE.Vector3[] => {

                const U: THREE.Vector3 = p1w.clone().sub(p1).normalize(); // ラベル文字方向.
                const V_FR: THREE.Vector3 = p2.clone().sub(p1).normalize(); // 前後ラベル高さ方向.
                const end: THREE.Vector3 = p1.clone().addScaledVector(U, -webcadDefines.LabelTexDefs.hgt * 0.5);

                const vec2 = end.clone().addScaledVector(V_FR, webcadDefines.LabelTexDefs.off);
                const vec3 = vec2.clone().addScaledVector(U, webcadDefines.LabelTexDefs.wid);
                const vec1 = vec2.clone().addScaledVector(V_FR, webcadDefines.LabelTexDefs.hgt);
                const vec4 = vec3.clone().addScaledVector(V_FR, webcadDefines.LabelTexDefs.hgt);

                return [vec1, vec2, vec3, vec4];
            }

            const get_vec4 = (p1w: THREE.Vector3, p1: THREE.Vector3, p2: THREE.Vector3): THREE.Vector3[] => {

                const cn: THREE.Vector3 = p1.clone().add(p2).divideScalar(2);
                const luFR: THREE.Vector3 = p2.clone().sub(p1).normalize(); // ラベル文字方向.
                const V_FR: THREE.Vector3 = p1w.clone().sub(p1).normalize(); // 上下ラベル高さ方向.

                const vec_ = cn.clone().addScaledVector(V_FR, -webcadDefines.LabelTexDefs.off);
                const vec1 = vec_.clone().addScaledVector(luFR, -webcadDefines.LabelTexDefs.wid / 2);
                const vec4 = vec_.clone().addScaledVector(luFR, webcadDefines.LabelTexDefs.wid / 2);
                const vec2 = vec1.clone().addScaledVector(V_FR, -webcadDefines.LabelTexDefs.hgt);
                const vec3 = vec4.clone().addScaledVector(V_FR, -webcadDefines.LabelTexDefs.hgt);

                return [vec1, vec2, vec3, vec4];
            }

            const getVec_front_rear = (dim_line: sizeType): THREE.Vector3[] => {
                if (dim_line.p2w == undefined) {
                    return get_vec3(dim_line.p1w, dim_line.p1, dim_line.p2);
                } else {
                    return get_vec4(dim_line.p1w, dim_line.p1, dim_line.p2);
                }
            }

            const total: number = sizes[0].length;

            // 上下ラベルの頂点配列. ( 個数 * 3角形X2 * xyz * 裏表 )
            const verticesTB: Float32Array = new Float32Array(total * 3 * 2 * 3 * 2);
            // 前後ラベルの頂点配列. 個数 * 3角形X2 * xyz * 裏表
            const verticesFR: Float32Array = new Float32Array(total * 3 * 2 * 3 * 2);
            let float_index: number = 0; // floatのindex
            const setCoordinate = (pointTB, pointFR) => {
                verticesTB[float_index] = pointTB.x;
                verticesFR[float_index++] = pointFR.x;
                verticesTB[float_index] = pointTB.y + 0.1;
                verticesFR[float_index++] = pointFR.y;
                verticesTB[float_index] = pointTB.z;
                verticesFR[float_index++] = pointFR.z;
            }

            // 頂点を登録[012][023]
            const texsture = [[0, 1], [0, 0], [1, 0], [0, 1], [1, 0], [1, 1]];
            const unitU_width: number = 1.0 / width; // u1つ分の幅.
            const unitV_width: number = 1.0 / height; // v1つ分の幅.
            let uv_index: number = 0; // uv配列のindex
            const uvBuffer = new Float32Array(total * 3 * 2 * 2 * 2); // 各頂点インデックスのuv配列. ( 個数 * 3角形X2 * uv * 裏表 )
            const setUV = (i: number, UVindex: number) => {
                uvBuffer[uv_index++] = unitU_width * (i + texsture[UVindex][0]);
                uvBuffer[uv_index++] = unitV_width * texsture[UVindex][1];
            }

            const indices = new Uint16Array(total * 3 * 2 * 1 * 2); // 頂点インデックス(3つ組). ( 個数 * 3角形X2 * vindex * 裏表 )
            let index_index: number = 0; // インデックスのindex
            let point_index: number = 0; // ポイントのindex
            const setIndex = () => {
                indices[index_index++] = point_index++;
            }

            const indicesTF = [0, 1, 2, 0, 2, 3];
            const indicesBR = [3, 2, 1, 3, 1, 0];
            for (let i = 0; i < total; i++) { // フロア毎.
                const dim_line = sizeArray[i];

                const pointsTB = getVec_top_bottom(dim_line); // 上下ラベルの4頂点を準備
                const pointsFR = getVec_front_rear(dim_line); // 前後ラベルの4頂点を準備

                // 頂点を登録[012][023]
                for (let j = 0; j < indicesTF.length; j++) {
                    setCoordinate(pointsTB[indicesTF[j]], pointsFR[indicesTF[j]]);
                    setUV(i, j); // UV
                    setIndex(); // indexのindex
                }
                for (let k = 0; k < indicesBR.length; k++) {
                    setCoordinate(pointsTB[indicesBR[k]], pointsFR[indicesBR[k]]);
                    setUV(i, k);
                    setIndex();
                }
            }

            const attr_uvs = new THREE.BufferAttribute(uvBuffer, 2);
            const attr_indices = new THREE.BufferAttribute(indices, 1);

            const matPlate = new THREE.MeshBasicMaterial({ transparent: true, color, map: texture });

            // 上下 寸法のジオメトリ作って、ひとまとめ     メモ：visibleがfalse.
            const attr_verticesTB = new THREE.BufferAttribute(verticesTB, 3);
            const bgeoTB = new THREE.BufferGeometry();
            bgeoTB.setAttribute('position', attr_verticesTB);
            bgeoTB.setAttribute('uv', attr_uvs);
            bgeoTB.setIndex(attr_indices);
            const meshPlateTB: THREE.Mesh = new THREE.Mesh(bgeoTB, matPlate);
            meshPlateTB.userData = { type: 'Label' };
            group2.name = "寸法数値 高さ（上下）";
            group2.add(meshPlateTB);

            // 前後 寸法のジオメトリ作って、ひとまとめ メモ：
            const attr_verticesFR = new THREE.BufferAttribute(verticesFR, 3);
            const bgeoFR = new THREE.BufferGeometry();
            bgeoFR.setAttribute('position', attr_verticesFR);
            bgeoFR.setAttribute('uv', attr_uvs);
            bgeoFR.setIndex(attr_indices);
            const meshPlateFR: THREE.Mesh = new THREE.Mesh(bgeoFR, matPlate);
            meshPlateFR.userData = { type: 'Label' };
            group1.name = "寸法数値 高さ（前後）";
            group1.add(meshPlateFR);

        }, 'center');
    }


    /* createFloorSizeLabelsObject
    * 各階の方向毎のサイズラベルを1つのオブジェクトとして生成する.
    */
    private createFloorSizeLabelsObject(arrays: marietta3d.AutoGen.object.AutoObjDimension[][], lvls: number[], group1: THREE.Group[], group2: THREE.Group[], color: string): void {
        const sizes: string[][] = [];
        let total: number = 0;
        for (let floor = 1; floor <= arrays.length; floor++) {
            const floorSizes: string[] = [];
            const array: marietta3d.AutoGen.object.AutoObjDimension[] = arrays[floor - 1];
            total += array.length;
            for (let m = 0; m < array.length; m++) floorSizes.push(array[m].dimStr);
            sizes.push(floorSizes);
        }
        // ラベルすべてを含むの広さのテクスチャ画像を作成.
        const levels: number[] = lvls;
        WebCadDimensionLine.createSizesTexture(sizes, webcadDefines.LabelTexDefs.fontSize, webcadDefines.LabelTexDefs.baseOff, webcadDefines.LabelTexDefs.texWid, webcadDefines.LabelTexDefs.texHgt, color, (texture: any, width: number, height: number) => {

            const getVec_top_bottom = (dim_line: any, lvl: number): THREE.Vector3[] => {

                const p1w = new THREE.Vector3(dim_line.p1w.x, 0, dim_line.p1w.y);
                const p1 = new THREE.Vector3(dim_line.p1.x, 0, dim_line.p1.y);
                const p2 = new THREE.Vector3(dim_line.p2.x, 0, dim_line.p2.y);

                const cn = new THREE.Vector3((dim_line.p1.x + dim_line.p2.x) / 2, lvl, (dim_line.p1.y + dim_line.p2.y) / 2);
                const lu: THREE.Vector3 = p2.clone().sub(p1).normalize(); // ラベル文字方向.
                const lvTB: THREE.Vector3 = p1w.clone().sub(p1).normalize(); // 上下ラベル高さ方向.

                // まず4頂点を準備.
                const vec_ = cn.clone().addScaledVector(lvTB, -webcadDefines.LabelTexDefs.off)
                const vec1 = vec_.clone().addScaledVector(lu, -webcadDefines.LabelTexDefs.wid / 2);
                const vec4 = vec_.clone().addScaledVector(lu, webcadDefines.LabelTexDefs.wid / 2);
                const vec2 = vec1.clone().addScaledVector(lvTB, -webcadDefines.LabelTexDefs.hgt);
                const vec3 = vec4.clone().addScaledVector(lvTB, -webcadDefines.LabelTexDefs.hgt);

                return [vec1, vec2, vec3, vec4];

            }

            const getVec_front_rear = (dim_line: any, lvl: number): THREE.Vector3[] => {

                const p1w = new THREE.Vector3(dim_line.p1w.x, 0, dim_line.p1w.y);
                const p1 = new THREE.Vector3(dim_line.p1.x, 0, dim_line.p1.y);
                const p2 = new THREE.Vector3(dim_line.p2.x, 0, dim_line.p2.y);

                const cn = new THREE.Vector3((dim_line.p1.x + dim_line.p2.x) / 2, lvl, (dim_line.p1.y + dim_line.p2.y) / 2);
                const lu: THREE.Vector3 = p2.clone().sub(p1).normalize(); // ラベル文字方向.
                const lvTB: THREE.Vector3 = p1w.clone().sub(p1).normalize(); // 上下ラベル高さ方向.
                const lvFR: THREE.Vector3 = lvTB.clone().cross(lu).normalize().negate(); // 前後ラベル高さ方向.

                // まず4頂点を準備.
                const vec_ = cn.clone().addScaledVector(lvFR, webcadDefines.LabelTexDefs.off);
                const vec2 = vec_.clone().addScaledVector(lu, -webcadDefines.LabelTexDefs.wid / 2);
                const vec3 = vec_.clone().addScaledVector(lu, webcadDefines.LabelTexDefs.wid / 2);
                const vec1 = vec2.clone().addScaledVector(lvFR, webcadDefines.LabelTexDefs.hgt);
                const vec4 = vec3.clone().addScaledVector(lvFR, webcadDefines.LabelTexDefs.hgt);

                return [vec1, vec2, vec3, vec4];

            }

            // 上下ラベルの頂点配列. 個数 * 3角形X2 * xyz * 裏表
            const verticesTB: Float32Array = new Float32Array(total * 3 * 2 * 3 * 2);
            // 前後ラベルの頂点配列. 個数 * 3角形X2 * xyz * 裏表
            const verticesFR: Float32Array = new Float32Array(total * 3 * 2 * 3 * 2);

            let float_index: number = 0; // floatのindex
            const setCoordinate = (pointTB, pointFR) => {
                verticesTB[float_index] = pointTB.x;
                verticesFR[float_index++] = pointFR.x;
                verticesTB[float_index] = pointTB.y + 0.1;
                verticesFR[float_index++] = pointFR.y;
                verticesTB[float_index] = pointTB.z;
                verticesFR[float_index++] = pointFR.z;
            }

            // 頂点を登録[012][023]
            const texsture = [[0, 1], [0, 0], [1, 0], [0, 1], [1, 0], [1, 1]];
            const txu: number = 1.0 / width; // u1つ分の幅.
            const txv: number = 1.0 / height; // v1つ分の幅.

            // 各頂点インデックスのuv配列. 個数 * 3角形X2 * uv * 裏表
            const uvs = new Float32Array(total * 3 * 2 * 2 * 2);
            let uv_index: number = 0; // uv配列のindex
            const setUV = (i:number, j: number, iTF: number) => {
                uvs[uv_index++] = txu * (j + texsture[iTF][0]);
                uvs[uv_index++] = txv * ((height - i - 1) + texsture[iTF][1]);
            }

            const indices = new Uint16Array(total * 3 * 2 * 1 * 2);
            let index_index: number = 0; // インデックスのindex
            let point_index: number = 0; // ポイントのindex
            const setIndex = () => {
                indices[index_index++] = point_index++;
            }

            // 寸法毎に頂点を配列に登録
            const set_coordinate = (i: number) => {
                for (let j = 0; j < sizes[i].length; j++) {　// 寸法毎.
                    const dim: marietta3d.AutoGen.object.AutoObjDimension = arrays[i][j];
                    dim.p1.y = -dim.p1.y; dim.p1w.y = -dim.p1w.y; dim.p2.y = -dim.p2.y; dim.p2w.y = -dim.p2w.y; // y(z)方向の符号が逆.
                    const lvl = levels[i + 1];
                    const psTB = getVec_top_bottom(dim, lvl);
                    const psFR = getVec_front_rear(dim, lvl);

                    // // 頂点を登録[012][023]
                    const idcsTF = [0, 1, 2, 0, 2, 3];
                    for (let iTF = 0; iTF < idcsTF.length; iTF++) {
                        setCoordinate(psTB[idcsTF[iTF]], psFR[idcsTF[iTF]]);
                        setUV(i, j, iTF);
                        setIndex();
                    }
                    const idcsBR = [3, 2, 1, 3, 1, 0];
                    for (let iBR = 0; iBR < idcsBR.length; iBR++) {
                        setCoordinate(psTB[idcsBR[iBR]], psFR[idcsBR[iBR]]);
                        setUV(i, j, iBR);
                        setIndex();
                    }
                }
            }

            for (let i = 0; i < sizes.length; i++) { // フロア毎.
                if (sizes[i].length <= 0) continue;

                // 頂点を配列に登録
                set_coordinate(i);

                const attr_uvs = new THREE.BufferAttribute(uvs, 2);
                const attr_indices = new THREE.BufferAttribute(indices, 1);

                const matPlate = new THREE.MeshBasicMaterial({ transparent: true, color, map: texture });

                const attr_verticesTB = new THREE.BufferAttribute(verticesTB, 3);
                const bgeoTB = new THREE.BufferGeometry();
                bgeoTB.setAttribute('position', attr_verticesTB);
                bgeoTB.setAttribute('uv', attr_uvs);
                bgeoTB.setIndex(attr_indices);
                const meshPlateTB: THREE.Mesh = new THREE.Mesh(bgeoTB, matPlate);
                meshPlateTB.userData = { type: 'Label' };
                if (group2[i] != undefined) {
                    group2[i].name = '寸法数値 横線（前後）';
                    group2[i].add(meshPlateTB);
                }

                const attr_verticesFR = new THREE.BufferAttribute(verticesFR, 3);
                const bgeoFR = new THREE.BufferGeometry();
                bgeoFR.setAttribute('position', attr_verticesFR);
                bgeoFR.setAttribute('uv', attr_uvs);
                bgeoFR.setIndex(attr_indices);
                const meshPlateFR: THREE.Mesh = new THREE.Mesh(bgeoFR, matPlate);
                meshPlateFR.userData = { type: 'Label' };
                if (group1[i] != undefined) {
                    group1[i].name = '寸法数値 横線（上下）';
                    group1[i].add(meshPlateFR);
                }

            }

        }, 'center');
    }

    /* setupSizeObjects
     * 寸法表示オブジェクトの生成.
     */
    public setupSizeObjects(plan: marietta3d.AutoGen.AutoBase, xSize: number, ySize: number, arrays: AutoObjDimension[][]): void {
        // 高さ方向の寸法ライングループ.
        ThreeView.get().wcItemmgr.sizesObjects.add('V');
        // 高さ方向の寸法ラベルXYグループ.
        ThreeView.get().wcItemmgr.sizesObjects.add('VXY', new THREE.Vector3(0, 1, 0), false);
        // 高さ方向の寸法ラベルZYグループ.
        ThreeView.get().wcItemmgr.sizesObjects.add('VZY', new THREE.Vector3(0, 1, 0), true);
        ThreeView.get().wcItemmgr.sizesObjects.setVisible('VZY', false);

        const level1 = Number(plan.Model.GetSlabLevel1());
        const level2 = Number(plan.Model.GetSlabLevel2());
        const level3 = Number(plan.Model.GetSlabLevel3());
        const level4 = Number(plan.Model.GetSlabLevel4());
        const lvls: number[] = [0,  level1/ 1000.0, level2 / 1000.0, level3 / 1000.0, level4 / 1000.0];

        const l: number = -(xSize / 1000) / 2.0 - 1.5;
        const r: number = -(xSize / 1000) / 2.0 - 1.0;
        const z: number = (ySize / 1000) / 2.0;

        const setSize1 = (floor): sizeType => {
            return {
                dimStr: String(Math.round((lvls[floor + 1] - lvls[floor + 0]) * 1000)),
                p1: new THREE.Vector3(l, lvls[floor + 0], z),
                p1w: new THREE.Vector3(r, lvls[floor + 0], z),
                p2: new THREE.Vector3(l, lvls[floor + 1], z),
                p2w: new THREE.Vector3(r, lvls[floor + 1], z),
            }
        }

        const setSize2 = (floor): sizeType => {
            return {
                dimStr: String(Math.round((lvls[floor + 0]) * 1000)),
                p1: new THREE.Vector3(l, lvls[floor + 0], z),
                p1w: new THREE.Vector3(r, lvls[floor + 0], z),
                p2: new THREE.Vector3(l, lvls[floor + 1], z),
                p2w: undefined,
            }
        }

        const plan_height = ThreeView.get().wcItemmgr.planHeight / 1000.0;
        const setSize3 = (floor): sizeType => {
            return {
                dimStr: String(Math.round((lvls[floor + 0]) * 1000)),
                p1: new THREE.Vector3(l, lvls[floor + 0], z),
                p1w: new THREE.Vector3(r, lvls[floor + 0], z),
                p2: new THREE.Vector3(l, plan_height, z),
                p2w: undefined,
            }
        }

        const setSize4 = (): sizeType => {
            return {
                dimStr: String(Math.round(plan_height * 1000)),
                p1: new THREE.Vector3(l, plan_height, z),
                p1w: new THREE.Vector3(r, plan_height, z),
                p2: new THREE.Vector3(l, plan_height + 1.0, z),
                p2w: undefined,
            }
        }

        // 家の土台部分のライン
        const set_foundation = (floor) => {
            geoV = [...geoV, ...this.addSizeLine(l, 0.05, z, r, 0.05, z),
             ...this.addSizeLine(l, 0.05, z, l, lvls[floor + 0], z),
             ...this.addSizeLine(l, lvls[floor + 0], z, r, lvls[floor + 0], z)];
        }

        // 床高から天井高まで
        const set_floorHeight = (floor) => {
            geoV = [...geoV, ...this.addSizeLine(l, lvls[floor + 1], z, r, lvls[floor + 1], z),
            ...this.addSizeLine(l, lvls[floor + 0], z, l, lvls[floor + 1], z)];
        }

        // 天井高から屋根の上まで
        const set_roofHeight = (floor) => {
            geoV = [...geoV, ...this.addSizeLine(l, plan_height, z, r, plan_height, z),
            ...this.addSizeLine(l, lvls[floor], z, l, plan_height, z)];
        }

        const sizeArray: sizeType[] = [];
        let geoV: THREE.Vector3[] = [];
        for (let floor = 1; floor <= webcadDefines.Limits.maxFloor + 1; floor++) {
            const isFloor = arrays.find((val) => val.find((value) => value.flr === floor));
            if (isFloor) {
                // 各階平面方向の寸法ライングループを用意しておく.
                ThreeView.get().wcItemmgr.sizesObjects.add(`L${floor}`);
                // 各階平面方向の寸法ラベルXZグループを用意しておく.
                ThreeView.get().wcItemmgr.sizesObjects.add(`LXZ${floor}`, new THREE.Vector3(0, 1, 0), false);
                // 各階平面方向の寸法ラベルYZグループを用意しておく.
                ThreeView.get().wcItemmgr.sizesObjects.add(`LYZ${floor}`, new THREE.Vector3(0, 1, 0), true);
                ThreeView.get().wcItemmgr.sizesObjects.setVisible('LYZ', false);

                // 家の土台部分の寸法線
                if (floor == 1) set_foundation(floor);

                // 床高から天井高まで寸法線
                set_floorHeight(floor);

                sizeArray.push(setSize1(floor));
                sizeArray.push(setSize2(floor));

            } else {

                // 天井高から屋根の上まで
                set_roofHeight(floor);

                sizeArray.push(setSize3(floor));
                sizeArray.push(setSize4());
                break;
            }
        }
        // 高さの方向のサイズラベルを1つのオブジェクトとして生成する.
        const grpVXY = ThreeView.get().wcItemmgr.sizesObjects.getObjects('VXY')[0];
        const grpVZY = ThreeView.get().wcItemmgr.sizesObjects.getObjects('VZY')[0];
        this.createHeightSizeLabelsObject(sizeArray, grpVXY, grpVZY, webcadDefines.ColorDefs.sizeColorStr);

        const mat = new THREE.LineBasicMaterial({color: webcadDefines.ColorDefs.sizeColor});
        // ラインをまとめて生成.
        const lineSegments = new THREE.LineSegments(WebCadDimensionLine.makePositionBufferGeometry(geoV), mat);
        ThreeView.get().wcItemmgr.sizesObjects.getObjects('V')[0].name = "寸法線 高さ";
        ThreeView.get().wcItemmgr.sizesObjects.getObjects('V')[0].add(lineSegments);

        const itemManager = ThreeView.get().wcItemmgr;
        if (arrays != undefined) {
            const LXZs: THREE.Group[] = [];
            const LYZs: THREE.Group[] = [];
            // 各階について平面寸法表示オブジェクトを準備する(非同期).
            for (let floor = 1; floor <= arrays.length; floor++) {
                let array: marietta3d.AutoGen.object.AutoObjDimension[] = arrays[floor - 1];

                // 各階平面方向の寸法ライングループを取得.
                const grpLs = <THREE.Group[]>itemManager.sizesObjects.getObjects('L' + floor);
                if (grpLs == undefined) continue;
                let grpL: THREE.Group = grpLs[0];
                console.assert(grpL.isGroup);

                // 各階平面方向の寸法ラベルXZグループを取得.
                const grpLXZs = <THREE.Group[]>itemManager.sizesObjects.getObjects('LXZ' + floor);
                if (grpLXZs == undefined) continue;
                let grpLXZ: THREE.Group = grpLXZs[0];
                console.assert(grpLXZ.isGroup);
                LXZs.push(grpLXZ);

                // 各階平面方向の寸法ラベルYZグループを取得.
                const grpLYZs = <THREE.Group[]>itemManager.sizesObjects.getObjects('LYZ' + floor);
                if (grpLYZs == undefined) continue;
                let grpLYZ: THREE.Group = grpLYZs[0];
                console.assert(grpLYZ.isGroup);
                LYZs.push(grpLYZ);

                const lvl: number = lvls[floor];
                let geoL: THREE.Vector3[] = [];
                for (let i = 0; i < array.length; i++) {
                    const dim: marietta3d.AutoGen.object.AutoObjDimension = array[i];
                    geoL = [...geoL, ...this.addSizeLine(dim.p1.x, lvl, -dim.p1.y, dim.p1w.x, lvl, -dim.p1w.y)];
                    geoL = [...geoL, ...this.addSizeLine(dim.p2.x, lvl, -dim.p2.y, dim.p2w.x, lvl, -dim.p2w.y)];
                    geoL = [...geoL, ...this.addSizeLine(dim.p1.x, lvl, -dim.p1.y, dim.p2.x, lvl, -dim.p2.y)];
                }
                grpL.name = "寸法線 平面";
                // ラインをまとめて生成.
                grpL.add(new THREE.LineSegments(WebCadDimensionLine.makePositionBufferGeometry(geoL), mat));
            }
            // 各階の方向毎のサイズラベルを1つのオブジェクトとして生成する.
            this.createFloorSizeLabelsObject(arrays, lvls, LXZs, LYZs, webcadDefines.ColorDefs.sizeColorStr);
        }
    }

    private static makePositionBufferGeometry(points: THREE.Vector3[]): THREE.BufferGeometry {
        const size: number = points.length * 3;
        const vertices = new Float32Array(size);
        let idx: number = 0;
        for (let i = 0; i < points.length; i++) {
            vertices[idx++] = points[i].x;
            vertices[idx++] = points[i].y;
            vertices[idx++] = points[i].z;
        }
        const bufferGeometry = new THREE.BufferGeometry;
        bufferGeometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
        return bufferGeometry;
    }

    private static createSizesTexture(sizes: string[][], fontSize: number, baseOff: number, usize: number, vsize: number, color: string, completion: any, align?: string): void {
        if (typeof document != 'undefined') {
            if (align == undefined) align = 'center';
            let canvas: HTMLCanvasElement = document.createElement('canvas');
            let width = 0;
            let height = 0;
            for (let i = 0; i < sizes.length; i++) {
                if (sizes[i].length > 0) height = i + 1;
                width = Math.max(width, sizes[i].length);
            }
            canvas.width = usize * width; canvas.height = vsize * height;
            const ctx: any = canvas.getContext('2d');
            ctx.font = String(fontSize) + "px sans-serif";
            ctx.textAlign = align;
            ctx.fillStyle = color;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.shadowBlur = 8;
            ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
            for (let j = 0; j < sizes.length; j++) {
                for (let k = 0; k < sizes[j].length; k++) {
                    ctx.fillText(sizes[j][k], usize * (k + 0.5), vsize * (j + 1) - baseOff);
                }
            }

            // テクスチャを作成
            let texture = new THREE.Texture(canvas);
            texture.needsUpdate = true;
            completion(texture, width, height);
        }
        else {
            completion(undefined);
        }
    }
}
